import { NwtColumnType, ProjectCategory, TpmColumnType } from '@/api-gateway';
import moment from 'moment';
export function genProjectName(project) {
    var name = '';
    if (project.regionCode) {
        name += project.regionCode.name;
    }
    if (project.projectCode) {
        name += project.projectCode.toString().padStart(4, '0');
    }
    if (project.subFormatCode) {
        name += "-" + project.subFormatCode.name + " ";
    }
    name += project.name;
    return name;
}
export function getAddress(project) {
    return project.address + " " + project.subdistrict + " " + project.district + " " + project.province + " " + project.postcode;
}
export function getReadableProjectCategory(category) {
    switch (category) {
        case ProjectCategory.NEWSTORE:
            return 'New Store';
        case ProjectCategory.REBRANDING:
            return 'Rebrand+/Refresh';
        case ProjectCategory.PLANNINGANDMALL:
            return 'Planning/Mall';
        case ProjectCategory.FM:
            return 'FM';
        default:
            return '-';
    }
}
export function formatDate(date) {
    if (!date)
        return '-';
    return moment(date).format('DD MMM YYYY');
}
export function formatDateTime(date) {
    if (!date)
        return '-';
    return moment(date).format('DD MMM YYYY HH:mm:ss');
}
export function getNwtMeetingType() {
    return [
        { value: NwtColumnType.SITE_FOR_DISCUSSION, text: 'Site For Discussion (for NWT)' },
        { value: NwtColumnType.UPDATE_NEXT_STEP_FROM_NWT, text: 'Update Next Step from NWT' },
        { value: NwtColumnType.NEW_SITE_PROPOSED, text: 'New Site Proposed' },
        { value: NwtColumnType.TAKE_TIME, text: 'Take Time' },
        { value: NwtColumnType.AOB, text: 'AOB' }
    ];
}
export function getTpmMeetingType() {
    return [
        { value: TpmColumnType.SITE_TO_TPM, text: 'Site to TPM' }
    ];
}
